import { all, call, put, takeLatest } from 'redux-saga/effects';
import { ICompatibilityReport } from '../api/models/compatibilityReport/compatibilityReport.types';
import { getCompatibilityReport } from '../api/repositories/member/member.sagas';
import { handleAsyncStatus } from '../asynchronousState/saga';
import { EAsyncEventTypes } from '../asynchronousState/types';
import {
  compatibilityReportActions,
  ECompatibilityReportActionType,
  ICompatibilityReportAction,
} from './actions';

export function* getCompatibilityReportSaga(
  action: ICompatibilityReportAction
) {
  const compatibilityReport: ICompatibilityReport = yield call(
    getCompatibilityReport,
    action.payload.reportType,
    action.payload.accountId
  );

  yield put(
    compatibilityReportActions.getCompatibilityReportSuccess({
      accountId: action.payload.accountId,
      reportType: action.payload.reportType,
      compatibilityReport,
    })
  );
}

export function* compatibilityReportRootSaga() {
  yield all([
    takeLatest(
      ECompatibilityReportActionType.GET,
      handleAsyncStatus(
        getCompatibilityReportSaga,
        EAsyncEventTypes.GET_COMPATIBILITY_REPORT
      )
    ),
  ]);
}
